import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { TransparentButton } from '../../ClickableComponents/Button';
import { PlayTransparentLink } from '../../ClickableComponents/PlayLink';
import { DialogActionSection } from '../DialogActionSection';
import { DialogContentWrapper } from '../DialogContentWrapper';
import { useDialogDispatch } from '../DialogContext';
import { DialogTextSection } from '../DialogTextSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureSurveyDialog = ({
  surveyLink,
  text,
  title
}) => {
  const {
    t
  } = useTranslation();
  const dispatchPopup = useDialogDispatch();
  return /*#__PURE__*/_jsx(DialogContentWrapper, {
    title: title,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(DialogTextSection, {
        title: title,
        children: /*#__PURE__*/_jsx(TextWrapper, {
          children: /*#__PURE__*/_jsx(Text, {
            children: text
          })
        })
      }), /*#__PURE__*/_jsxs(DialogActionSection, {
        children: [/*#__PURE__*/_jsx(TransparentButton, {
          type: "text",
          text: t('global.notNow'),
          onClick: () => dispatchPopup({
            type: 'remove-dialog'
          })
        }), /*#__PURE__*/_jsx(PlayTransparentLink, {
          fontSize: {
            mediaQuery: [],
            default: 16
          },
          text: t('global.participateFeedback'),
          to: surveyLink,
          onClick: () => {
            dispatchPopup({
              type: 'remove-dialog'
            });
          },
          openInNewTab: true
        })]
      })]
    })
  });
};
const TextWrapper = styled.div.withConfig({
  displayName: "FeatureSurveyDialog__TextWrapper",
  componentId: "sc-6mg99i-0"
})(["margin-top:24px;"]);
const Text = styled.span.withConfig({
  displayName: "FeatureSurveyDialog__Text",
  componentId: "sc-6mg99i-1"
})(["white-space:pre-wrap;color:", ";", ";line-height:24px;"], Colors.GREY_d2d2d2, Fonts.regular(16));
const Container = styled.div.withConfig({
  displayName: "FeatureSurveyDialog__Container",
  componentId: "sc-6mg99i-2"
})(["display:flex;flex-direction:column;max-width:382px;"]);